import axios from "axios";

const baseDomain = "https://hst.medical-data.ru";
const baseURL = `${baseDomain}/hst`;

const instance = axios.create({
  baseURL,
});

const catchReturn = (error, data = {}) => {
  let status, text;
  if (error.response) {
    // Запрос выполнен, и сервер отправил статус код вне диапазона 2xx
    status = error.response.status;
    text = error.message;
    // } else if (error.request) {
    //   // Запрос был сделан, но ответ не получен
    //   text = error.message;
  } else {
    text = error.message;
  }
  return {
    data,
    connector_state: { status, text, isError: true },
  };
};

instance.catchReturn = catchReturn;

export default instance;
